/**
 * Every message that crosses the wire is named here and typed below. Client and
 * server both import this, so a rename breaks the build instead of production.
 *
 * Excepción: el canal social tiene su propio juego de mensajes en `social.ts`, junto
 * a los DTOs de sus endpoints. Son dos conversaciones distintas —una de sala, otra de
 * cuenta— y mezclarlas invitaría a mandar una por el canal de la otra.
 */
export const Msg = {
    /** client -> server: "I clicked here, walk me there." */
    Move: "move",
    /** client -> server: raw chat text, unfiltered. */
    Chat: "chat",
    /** client -> server: "quiero usar este objeto del mapa". */
    UseElement: "element:use",
    /**
     * client -> server: ponerse o quitarse un ítem.
     *
     * Va por la sala y no por HTTP porque el estado sincronizado vive acá: equipar
     * tiene que verse al instante para los demás. Comprar sí es HTTP — eso es una
     * transacción, no una acción de juego.
     */
    Equip: "equip",
    /**
     * client -> server: "vuelve a leer mi perfil de la base".
     *
     * Sin payload a propósito: es una INTENCIÓN, y lo que se relee —hoy los clubes— lo
     * decide el servidor. Existe porque entrar a un club pasa por HTTP y su insignia
     * vive en el estado de la sala, así que sin esto no aparecería hasta cruzar una
     * puerta.
     */
    RefreshProfile: "profile:refresh",
    /**
     * client -> server: "quiero hacer este gesto".
     *
     * Es una INTENCIÓN como `Msg.Move`: el cliente nombra el gesto y el servidor decide
     * si vale, cuánto dura y cuándo se apaga. Sin eso, el tope y la caducidad vivirían
     * en el cliente, que es donde no sirven de nada.
     */
    Gesture: "gesture",
    /*
     * Acá vivió `RefreshRoom`, con el que el cliente le pedía a su sala que releyera los
     * muebles del iglú. Duró poco y se borró a propósito: un aviso que depende de que el
     * cliente se acuerde de mandarlo falla justo donde importa —otra pestaña, otro
     * dispositivo—, y la sala se quedaba simulando el cuarto viejo mientras el jugador
     * atravesaba la silla que acababa de poner.
     *
     * Ahora avisa el SERVIDOR: los endpoints que escriben llaman a la sala por
     * `matchMaker.remoteRoomCall`. Ver `avisarAlIglu` en el módulo del iglú.
     */
    /** server -> clients: chat that passed filtering and rate limits. */
    ChatSaid: "chat:said",
    /** server -> one client: your message was rejected, and why. */
    ChatRejected: "chat:rejected",
    /** server -> one client: no te pudiste poner eso, y por qué. */
    EquipRejected: "equip:rejected",
    /** server -> one client: la puerta se aceptó; entra a esta sala. */
    RoomChanged: "room:changed",
    /**
     * server -> one client: llegaste a un objeto que abre un panel.
     *
     * Lo manda el SERVIDOR y no lo decide el cliente al hacer clic, por lo mismo que
     * una puerta: el objeto se usa desde cerca, y quien comprueba la cercanía es la
     * sala. Si el cliente abriera la tienda por su cuenta al tocar el mostrador,
     * comprar desde el otro extremo del mapa sería cuestión de mandar un clic falso.
     */
    OpenPanel: "panel:open",
    /**
     * Abre el directorio de clubes, con el filtro del sitio desde donde se pidió.
     *
     * Lo manda el servidor al tocar el tablón, y no lo abre el cliente por su cuenta, por
     * lo mismo que la tienda: lo que abre el directorio es haber LLEGADO hasta él, y eso
     * sólo lo sabe la sala. El filtro viaja en el mensaje porque es del sitio —el del
     * edificio de la FIEC enseña los suyos— y no de quien mira.
     */
    ClubDirectory: "club:directory",
};
/**
 * Cierre: te echaron del mundo porque tu cuenta lo abrió en otro sitio.
 *
 * Va en shared y no en el servidor porque es el mismo número en las dos puntas: el
 * servidor cierra con él y el cliente decide qué contar. Está en el rango de aplicación
 * (4000-4999) y separado del 4401 del canal social —token muerto— porque son dos cosas
 * distintas: de ésta se vuelve entrando otra vez, de aquélla hay que iniciar sesión.
 *
 * Ver `rooms/presence.ts`: una cuenta, un sitio, y gana la conexión nueva.
 */
export const DESALOJADO = 4100;
//# sourceMappingURL=protocol.js.map